import axios from "axios";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
export function filters() {
    const { t } = useI18n();
    const productCategories = ref([]);
    const selectedProductCategories = ref([]);
    const materials = ref([]);
    const selectedMaterials = ref([]);
    const volumes = ref([]);
    const selectedVolumes = ref([]);
    const bottleHeights = ref([]);
    const selectedBottleHeights = ref([]);
    const sodaStreamOptions = ref([
        { name: t("Soda-Stream-Eignung irrelevant"), value: 0 },
        { name: t("Soda-Stream-Eignung"), value: 1 },
    ]);
    const selectedSodaStreamOption = ref(0);
    function loadAvailableProductCategories(tenantId, onlyForBottles = false) {
        axios
            .post(route("configurator.productCategories.load"), {
            tenantId: tenantId,
            onlyForBottles: onlyForBottles
        })
            .then((response) => {
            productCategories.value = response.data;
        })
            .catch((error) => { });
    }
    function loadAvailableMaterials(tenantId) {
        axios
            .post(route("configurator.materials.load"), {
            tenantId: tenantId,
        })
            .then((response) => {
            materials.value = response.data;
        })
            .catch((error) => { });
    }
    function loadAvailableVolumes(tenantId) {
        axios
            .post(route("configurator.bottles.volumes.load"), {
            tenantId: tenantId,
        })
            .then((response) => {
            volumes.value = response.data;
        })
            .catch((error) => { });
    }
    function loadAvailableBottleHeights(tenantId) {
        axios
            .post(route("configurator.bottles.heights.load"), {
            tenantId: tenantId,
        })
            .then((response) => {
            bottleHeights.value = response.data;
        })
            .catch((error) => { });
    }
    function loadFilters(tenantId, onlyForBottles = false) {
        loadAvailableProductCategories(tenantId, onlyForBottles),
            loadAvailableMaterials(tenantId),
            loadAvailableVolumes(tenantId),
            loadAvailableBottleHeights(tenantId);
    }
    async function searchBottles(tenantId, selectedProductCategories, selectedMaterials, selectedVolumes, selectedBottleHeights, selectedSodaStreamOption, componentUuid) {
        const response = await axios.post(route('configurator.bottles.selection.index'), {
            tenantId: tenantId,
            product_categories: selectedProductCategories,
            materials: selectedMaterials,
            volumes: selectedVolumes,
            bottle_heights: selectedBottleHeights,
            soda_stream_option: selectedSodaStreamOption,
            component_uuid: componentUuid
        });
        return response.data;
    }
    async function searchAccessoryProducts(tenantId, selectedProductCategories, selectedMaterials, componentUuid) {
        const response = await axios.post(route('configurator.accessoryProducts.selection.index'), {
            tenantId: tenantId,
            product_categories: selectedProductCategories,
            materials: selectedMaterials,
            component_uuid: componentUuid
        });
        return response.data;
    }
    return {
        productCategories,
        selectedProductCategories,
        materials,
        selectedMaterials,
        volumes,
        selectedVolumes,
        bottleHeights,
        selectedBottleHeights,
        sodaStreamOptions,
        selectedSodaStreamOption,
        loadFilters,
        searchBottles,
        searchAccessoryProducts
    };
}
